// Cross-platform confirm/alert utility
// Fixes Alert.alert not working properly on React Native Web
import { Platform, Alert } from 'react-native';

/**
 * Show a confirmation dialog that works on both web and native.
 * @param {string} title - Dialog title
 * @param {string} message - Dialog message
 * @param {Function} onConfirm - Callback when user confirms
 * @param {string} confirmText - Confirm button text (default: '确定')
 */
export function confirmAction(title, message, onConfirm, confirmText = '确定') {
    if (Platform.OS === 'web') {
        if (window.confirm(`${title}\n\n${message}`)) {
            onConfirm();
        }
    } else {
        Alert.alert(title, message, [
            { text: '取消', style: 'cancel' },
            { text: confirmText, onPress: onConfirm }
        ]);
    }
}

/**
 * Show a simple alert message.
 * @param {string} title - Alert title
 * @param {string} message - Alert message (optional)
 */
export function showAlert(title, message = '') {
    if (Platform.OS === 'web') {
        window.alert(message ? `${title}\n\n${message}` : title);
    } else {
        Alert.alert(title, message);
    }
}
